import { Box, CircularProgress, DialogActions, DialogContent, DialogTitle, FormControlLabel, IconButton, Switch, TextField, FormControl, InputLabel, MenuItem, Select, Typography, Grid, FormLabel, FormGroup, Checkbox } from '@mui/material';
import MDButton from 'components/MDButton';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { fetchReturnDetails } from '../../../redux/slices/orders';
import { useDispatch } from 'react-redux';
import { fetchRefundList } from '../../../redux/slices/common';
import { getData } from 'utilities/common';
import { Riple } from 'react-loading-indicators';

export default function WarrantyReason({ closeModal }) {
  const dispatch = useDispatch()
  const { modalData } = useSelector(state => state.modal);
  const { loading: submittingOrder = false, isUpdatingStatus = false, returnData } = useSelector(state => state.orders);
  const [items, setItems] = useState([]);
  const [refundListData, setRefundListData] = useState([]);
  const user = getData('login-user-info')
  const parseUser = JSON.parse(user)

  const [errors, setErrors] = useState({});
  const [error, setError] = useState('');

  const { orderId, status, warrantyStatusHanlder, returnItems } = modalData || {};
  const [formData, setFormData] = useState({
    returnApprovedStatus: status,
    orderId: orderId,
    approvalComment: "",
    cancellationReasonOther: "",
    approvedItems: [],
    updatedBy: parseUser?.name
  });
  const [openReasonIndex, setOpenReasonIndex] = useState(null); // Track which item's reason is open
  const [selectPayload, setSelectPayload] = useState([]); // Stores selected items
  const [isSelectAll, setIsSelectAll] = useState(false); // Tracks Select All status
  const [errorsReject, setErrorsReject] = useState({});

  const submitHandler = () => {
    const hasSelectedItem = formData?.approvedItems?.some(item => item.acceptRequest);

    if (!hasSelectedItem) {
      setError('Please select at least one product.');
      return;
    }

    // let newErrors = {}; // Store errors for all items
    // let hasError = false; // Track if any error exists
    // formData?.approvedItems?.forEach((item, index) => {
    //   if (!item?.approvalComment) {
    //     newErrors[`approvalComment-${index}`] = "Reason is required";
    //     hasError = true;
    //   }

    //   if (item?.approvalComment === "Other Reason" && !item?.cancellationReasonOther?.trim()) {
    //     newErrors[`cancellationReasonOther-${index}`] = "Other reason is required";
    //     hasError = true;
    //   }
    // });
    // if (hasError) {
    //   setErrors((prevErrors) => ({ ...prevErrors, ...newErrors }));
    //   return; // Stop execution if any error exists
    // }

    let newErrors = {}; // Store errors for all items
    let hasError = false; // Track if any error exists

    formData?.approvedItems?.forEach((item, index) => {
      // Check only if acceptRequest is true
      if (item?.acceptRequest) {
        if (!item?.approvalComment) {
          newErrors[`approvalComment-${index}`] = "Reason is required";
          hasError = true;
        }

        if (item?.approvalComment === "Other Reason" && !item?.cancellationReasonOther?.trim()) {
          newErrors[`cancellationReasonOther-${index}`] = "Other reason is required";
          hasError = true;
        }
      }
    });

    if (hasError) {
      setErrors((prevErrors) => ({ ...prevErrors, ...newErrors }));
      return; // Stop execution if any error exists
    }

    // ********************************* new using key****************************
    const payload = {
      returnApprovedStatus: status,
      orderId: orderId,
      updatedBy: parseUser?.name,
      ...(status && {
        approvedItems: formData?.approvedItems
          .filter(item => item.acceptRequest) // Only include items with acceptRequest = true
          .map(({ approvalComment, cancellationReasonOther, productId, isReturned, productPrice,  requestQtysubmit }) => ({
            productId,
            isReturned,
            productPrice,
            requestedQty: requestQtysubmit,
            approvalComment: approvalComment === 'Other Reason' ? cancellationReasonOther : approvalComment,
            // proportionalDiscount
          }))
      })
    };


    //      **************************************base seprate state ******************************
    // const payload = {
    //   returnApprovedStatus: status,
    //   orderId: orderId,
    //   // approvalComment: formData?.approvalComment === 'Other Reason' ? formData?.cancellationReasonOther : formData?.approvalComment,
    //   updatedBy: parseUser?.name,
    //   ...(status && {
    //     approvedItems: selectPayload.map(({ approvalComment, cancellationReasonOther, productId, isReturned, productPrice, requestedQty, requestQtysubmit }) => ({
    //       productId,
    //       isReturned,
    //       productPrice,
    //       requestedQty: requestQtysubmit,
    //       approvalComment: approvalComment === 'Other Reason' ? cancellationReasonOther : approvalComment
    //     }))
    //   })
    // };
    setErrors({});
    warrantyStatusHanlder(payload);
  };

  const submitHandlerRejection = () => {
    if (!formData?.approvalComment) {
      setErrorsReject({ approvalComment: 'Reason is required' });
      return
    }
    if (formData?.approvalComment === 'Other Reason') {
      if (!formData?.cancellationReasonOther) {
        setErrorsReject({ cancellationReasonOther: 'Other  Reason is required' });
        return
      }
    }
    const payload = {
      returnApprovedStatus: status,
      orderId: orderId,
      approvalComment: formData?.approvalComment === 'Other Reason' ? formData?.cancellationReasonOther : formData?.approvalComment,
      updatedBy: parseUser?.name
    }
    setErrors({});
    warrantyStatusHanlder(payload);
  }

  useEffect(() => {
    dispatch(fetchReturnDetails(orderId)).unwrap()
      .then((res) => {
        const updatedItems = res?.returnItemsDetails.map(item => ({
          ...item,
          isReturned: false,
          requestQtysubmit: item?.requestedQty
        }));

        // Set updated items in formData's approvedItems
        setFormData(prevFormData => ({
          ...prevFormData,
          approvedItems: updatedItems
        }));
      })
      .catch((err) => {
      });
  }, [orderId]);

  const toggleReturnStatus = (productId) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      approvedItems: prevFormData.approvedItems.map(item =>
        item.productId === productId
          ? { ...item, isReturned: !item.isReturned }
          : item
      )
    }));
  };

  useEffect(() => {
    dispatch(fetchRefundList()).unwrap().then((res) => {
      setRefundListData(res?.refundReasons)
    });
  }, [])

  const handleSaveReason = (index) => {
    const selectedItem = formData?.approvedItems?.[index]; // Get the specific item
    if (!selectedItem?.approvalComment) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [`approvalComment-${index}`]: "Reason is required"
      }));
      return; // Stop execution if reason is missing
    }

    if (selectedItem?.approvalComment === "Other Reason" && !selectedItem?.cancellationReasonOther?.trim()) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [`cancellationReasonOther-${index}`]: "Other reason is required"
      }));
      return; // Stop execution if other reason is empty
    }

    // If validation passes, save the reason
    setFormData((prevFormData) => {
      const updatedApprovedItems = [...prevFormData.approvedItems];
      updatedApprovedItems[index] = {
        ...updatedApprovedItems[index],
      };

      return { ...prevFormData, approvedItems: updatedApprovedItems };
    });

    // Clear errors if valid
    setErrors((prevErrors) => ({
      ...prevErrors,
      [`approvalComment-${index}`]: "",
      [`cancellationReasonOther-${index}`]: ""
    }));

    setOpenReasonIndex(null); // Close the reason input after saving
  };

  // const handleSaveReason = (index) => {


  //   // setOpenReasonIndex(null); // Close the reason input after saving
  // };
  const startTaskHandler = (e, index) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => {
      const updatedApprovedItems = [...prevFormData.approvedItems]; // Clone array

      updatedApprovedItems[index] = {
        ...updatedApprovedItems[index], // Keep existing data
        [name]: value, // Update changed field
      };

      // If approvalComment is changed and is NOT "Other Reason", reset cancellationReasonOther
      if (name === "approvalComment" && value !== "Other Reason") {
        updatedApprovedItems[index].cancellationReasonOther = "";
      }

      return {
        ...prevFormData,
        approvedItems: updatedApprovedItems,
      };
    });

    // Clear any errors related to the updated field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [`${name}-${index}`]: "",
      ...(name === "approvalComment" && value !== "Other Reason"
        ? { [`cancellationReasonOther-${index}`]: "" }
        : {}),
    }));
  };

  // const startTaskHandler = (e, index) => {
  //   const { name, value } = e.target;

  //   setFormData((prevFormData) => {
  //     const updatedApprovedItems = [...prevFormData.approvedItems]; // Clone the array
  //     updatedApprovedItems[index] = {
  //       ...updatedApprovedItems[index], // Keep other product details
  //       [name]: value // Update only the changed field
  //     };

  //     return {
  //       ...prevFormData,
  //       approvedItems: updatedApprovedItems // Update approvedItems
  //     };
  //   });

  //   setErrors((prevErrors) => ({
  //     ...prevErrors,
  //     [`${name}-${index}`]: "" // Clear errors for the specific item
  //   }));
  // };
  // const startTaskHandler = (e) => {
  //   const { name, value } = e.target;

  //   setFormData({
  //     ...formData,
  //     [name]: value
  //   });

  //   setErrors({
  //     ...errors,
  //     [name]: ""
  //   });
  // };

  const updateQty = (productId, change, maxQty) => {
    setFormData((prev) => ({
      ...prev,
      approvedItems: prev.approvedItems.map((item) =>
        item.productId === productId
          ? { ...item, requestQtysubmit: Math.min(maxQty, Math.max(0, item.requestQtysubmit + change)) }
          : item
      ),
    }));
  };

  const handleReasonToggle = (index) => {
    setOpenReasonIndex(openReasonIndex === index ? null : index);
  };

  // const handleSingleSelect = (item) => {
  //   setSelectPayload((prevSelected) => {
  //     const isAlreadySelected = prevSelected.some((selectedItem) => selectedItem.productId === item.productId);

  //     let updatedSelection;
  //     if (isAlreadySelected) {
  //       // Remove item
  //       updatedSelection = prevSelected.filter((selectedItem) => selectedItem.productId !== item.productId);
  //     } else {
  //       // Add item
  //       updatedSelection = [...prevSelected, item];
  //     }

  //     // Update Select All state
  //     setIsSelectAll(updatedSelection.length === formData.approvedItems.length);

  //     return updatedSelection;
  //   });
  // };

  // const handleSelectAll = () => {
  //   if (isSelectAll) {
  //     // Deselect all
  //     setSelectPayload([]);
  //   } else {
  //     // Select all
  //     setSelectPayload([...formData.approvedItems]);
  //   }
  //   setIsSelectAll(!isSelectAll);
  // };


  const handleSingleSelect = (item) => {
    setErrors({})
    setError("")
    setFormData((prevFormData) => {
      const updatedApprovedItems = prevFormData.approvedItems.map((approvedItem) =>
        approvedItem.productId === item.productId
          ? { ...approvedItem, acceptRequest: !approvedItem.acceptRequest }
          : approvedItem
      );

      return {
        ...prevFormData,
        approvedItems: updatedApprovedItems,
      };
    });
    const allChecked = formData.approvedItems.every((item) => item.acceptRequest);
    setIsSelectAll(allChecked);

    // Update Select All state
    // setIsSelectAll(formData.approvedItems.every((item) => item.acceptRequest));
  };

  const handleSelectAll = () => {
    setErrors({})
    const allSelected = !isSelectAll;
    setError("")

    setFormData((prevFormData) => {
      const updatedApprovedItems = prevFormData.approvedItems.map((item) => ({
        ...item,
        acceptRequest: allSelected,
      }));

      return {
        ...prevFormData,
        approvedItems: updatedApprovedItems,
      };
    });

    setIsSelectAll(allSelected);
  };
  useEffect(() => {
    const allChecked = formData.approvedItems.every((item) => item.acceptRequest);
    setIsSelectAll(allChecked);
  }, [formData.approvedItems]); // Runs when approvedItems change

  const startTaskHandlerReject = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

    setErrors({
      ...errors,
      [name]: ""
    });
  };

  return (
    <div className="approval-reason-modal">
      <DialogTitle id='draggable-dialog-title' display='flex' alignItems='center' justifyContent='space-between'>
        {status ? 'Approval' : 'Rejection'} Reason
        <div className='d-flex align-item-center gap-4'>
          {
            status &&
            <FormControl component="fieldset">
              <FormGroup aria-label="position" row>
                {/* <FormControlLabel
                value="selectAll"
                control={<Checkbox checked={isSelectAll}
                  onChange={handleSelectAll} />}
                label="Accept All Request"
                labelPlacement="selectAll"
              /> */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isSelectAll}
                      onChange={handleSelectAll}
                    />
                  }
                  label="Accept All Request"
                />
              </FormGroup>
              <p className='error'>{error}</p>
            </FormControl>
          }
          <IconButton onClick={closeModal} edge='end' size='small'>
            <CloseIcon fontSize='medium' />
          </IconButton>
        </div>
      </DialogTitle>
      {
        submittingOrder ? <div className='modal-body-loader text-center'>
          <Riple color='#3135cc' size='medium' text='' textColor='' />
        </div> :
          <DialogContent>
            {
              status ?
                <Box className="table-box">
                  <ul className='w-100'>
                    {
                      formData?.approvedItems?.map((data, index) => {

                        return (
                          <li key={items}>
                            <div className='w-100 d-flex align-item-center jc-s-btwn gap-3 mb-2 pro-title-reason'>
                              <h4>{data?.productName}</h4>

                              <FormControl component="fieldset" style={{ minWidth: "80px" }}>
                                <FormGroup aria-label="position" row>
                                  {/* <FormControlLabel
                                  value="selectItem"
                                  control={
                                    <Checkbox
                                      checked={selectPayload.some((selectedItem) => selectedItem.productId === data.productId)}
                                      onChange={() => handleSingleSelect(data)}
                                    />
                                  }
                                  label="Accept Request"
                                  labelPlacement="selectItem"
                                /> */}
                                  <FormControlLabel
                                    value="selectItem"
                                    control={
                                      <Checkbox
                                        checked={data.acceptRequest || false}
                                        onChange={() => handleSingleSelect(data)}
                                      />
                                    }
                                    label="Accept Request"
                                    labelPlacement="end"
                                  />
                                </FormGroup>
                              </FormControl>
                            </div>

                            <div className={!data?.acceptRequest ? "order-list-reason opacity-box": 'order-list-reason'}>
                              <Box>
                                <label>Qty to Refund</label>
                                <div className="plus-mins-qty">
                                  <button
                                    className="minus"
                                    onClick={() => updateQty(data.productId, -1, data.requestedQty)}
                                    // disabled={data.requestQtysubmit === 1} // Disable at min limit
                                    disabled={data.requestQtysubmit === 1 || !data.acceptRequest}

                                  >
                                    -
                                  </button>
                                  <span className="num">{data.requestQtysubmit}</span>
                                  <button
                                    className="plus"
                                    onClick={() => updateQty(data.productId, 1, data.requestedQty)}
                                    // disabled={data.requestQtysubmit >= data.requestedQty} // Disable at max limit
                                    disabled={data.requestQtysubmit >= data.requestedQty || !data.acceptRequest}

                                  >
                                    +
                                  </button>
                                </div>
                              </Box>
                              <Box>
                                <label>Return to Stock</label>
                                <div className='qty-to-return'>
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        disabled={data.acceptRequest ? false : true}
                                        checked={data.isReturned}
                                        onChange={() => toggleReturnStatus(data.productId)}
                                        color="primary"
                                      />
                                    }
                                    label={`Qty to Return: ${data?.requestQtysubmit}`}
                                  />
                                </div>
                              </Box>
                              <Box>
                                <label>Qty left</label>
                                {data.isReturned ? <p>{data?.quantity + data?.requestQtysubmit}</p> : <p>{data?.quantity}</p>}
                              </Box>
                              <Box>
                                <label>Price Per Qty</label>
                                <p>${data?.productPrice}</p>
                              </Box>
                              <Box>
                                <label>Amount Refund</label>
                                <p>${data?.productPrice * data?.requestQtysubmit}</p>
                              </Box>
                            </div>

                            <div className={!data?.acceptRequest ? "pro-reason-area opacity-box": 'pro-reason-area'}>
                              {
                                data.acceptRequest ?
                                  <button className='add-reason-btn' onClick={() => handleReasonToggle(index)}>
                                    {openReasonIndex === index ? "- Add Reason" : "+ Add Reason"}
                                    {/* {openReasonIndex === index && data?.approvalComment
                                    ? " Change Reason"
                                    : data?.approvalComment
                                      ? "Change Reason"
                                      : "+ Add Reason"} */}

                                  </button> :
                                  <button className='add-reason-btn'>
                                    {openReasonIndex === index ? "- Add Reason" : "+ Add Reason"}
                                  </button>

                              }
                              {
                                openReasonIndex === index ? null
                                  : <div className='w-100 d-flex flex-column mt-2'>
                                    {
                                      errors[`approvalComment-${index}`] ? <p className="error">{errors[`approvalComment-${index}`]}</p> : errors[`cancellationReasonOther-${index}`] ? <p className="error">{errors[`cancellationReasonOther-${index}`]}</p> :
                                        <p style={{ fontSize: "14px", color: "#2E2E3A", wordBreak: "break-word" }}>
                                          {data?.approvalComment === 'Other Reason' ? data?.cancellationReasonOther : data?.approvalComment
                                          }
                                        </p>
                                    }</div>
                              }


                              {openReasonIndex === index && (
                                <div className='add-reason-container'>
                                  <FormControl fullWidth>
                                    <InputLabel>Add Reason</InputLabel>
                                    <Select
                                      size='large'
                                      fullWidth
                                      className='form-select'
                                      name={`approvalComment`}
                                      value={data.approvalComment}
                                      onChange={(e) => startTaskHandler(e, index)}
                                      label='Add Reason'
                                      MenuProps={{ className: 'refund-popover' }}
                                    >
                                      {refundListData?.map((option, idx) => (
                                        <MenuItem key={idx} value={option?.refundReason}>
                                          {option?.refundReason}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                    <p className="error">{errors[`approvalComment-${index}`]}</p> {/* Show error if missing reason */}
                                  </FormControl>

                                  {data.approvalComment === 'Other Reason' && (
                                    <FormControl fullWidth>
                                      <TextField
                                        fullWidth
                                        error={Boolean(errors[`cancellationReasonOther-${index}`])}
                                        helperText={errors[`cancellationReasonOther-${index}`]}
                                        className='form-input'
                                        label='Add other Reason'
                                        name={`cancellationReasonOther`}
                                        onChange={(e) => startTaskHandler(e, index)}
                                        multiline
                                        value={data.cancellationReasonOther}
                                        rows={4}
                                      />
                                    </FormControl>
                                  )}

                                  <div className='w-100 d-flex gap-2'>
                                    <MDButton onClick={() => handleSaveReason(index)} // Call save function
                                      size='small' color='primary' sx={{ minWidth: '100px', padding: '0.5rem 1.5rem' }}>
                                      Save
                                    </MDButton>
                                    <MDButton
                                      size='small'
                                      variant="outlined"
                                      color="dark"
                                      sx={{ minWidth: '100px', padding: '0.5rem 1.5rem' }}
                                      onClick={() => handleReasonToggle(null)}
                                    >
                                      Cancel
                                    </MDButton>
                                  </div>
                                </div>
                              )}
                            </div>
                          </li>
                        )
                      })
                    }
                  </ul>

                </Box>
                :
                <>
                  <Box>
                    <Typography variant='h6' fontWeight="semibold" mb={1}>Add Reason</Typography>
                    <FormControl fullWidth>
                      <InputLabel>Add Reason</InputLabel>
                      <Select
                        size='large'
                        fullWidth
                        className='form-select'
                        name='approvalComment'
                        sx={{
                          '& .MuiSelect-select': {
                            paddingRight: "2rem !important",
                            width: "calc(100% - 90px)"
                          }
                        }}
                        value={formData?.approvalComment} onChange={(e) => { startTaskHandlerReject(e) }}
                        label='Add Reason'
                        MenuProps={{ className: 'refund-popover' }}
                      >
                        {
                          refundListData?.map((data, idx) => {
                            return (
                              <MenuItem key={idx} value={data?.refundReason}>{data?.refundReason}</MenuItem>
                            )
                          })
                        }
                      </Select>
                      <p className="error">{errorsReject?.approvalComment}</p>
                    </FormControl>
                  </Box>
                  {
                    formData?.approvalComment === 'Other Reason' &&
                    <Grid item xs={12} sm={12} xl={12} mt={3}>
                      <FormControl fullWidth>
                        <TextField
                          fullWidth
                          error={Boolean(errorsReject?.cancellationReasonOther)}
                          helperText={errorsReject?.cancellationReasonOther}
                          className='form-input'
                          label='Add other Reason'
                          name='cancellationReasonOther'
                          onChange={(e) => { startTaskHandlerReject(e) }}
                          multiline
                          rows={4}
                        />
                      </FormControl>
                    </Grid>
                  }</>
            }
            <Typography variant='body2' className='error' style={{ paddingTop: "10px"}}> Note: This {status ? "approval" : "rejection"}  cannot be modified.</Typography>


          </DialogContent>
      }
      <DialogActions>
        <MDButton onClick={closeModal} size='large' variant="outlined" color="dark" sx={{ minWidth: '150px', padding: '0.25rem 1.5rem' }}>
          Cancel
        </MDButton>

        <MDButton disabled={submittingOrder || isUpdatingStatus} onClick={status ? submitHandler : submitHandlerRejection} size='large' color='primary' sx={{ minWidth: '150px', padding: '0.25rem 1.5rem' }}>
          {
            submittingOrder || isUpdatingStatus ? <CircularProgress size={16} color='light' /> : <>
              {status ? 'Approve Return' : "Save"}
            </>
          }
        </MDButton>
      </DialogActions>
    </div>
  );
}

